import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import cn from 'classname';
import { actions } from './../../../../../../modules/profile';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const propTypes = {
	intl: PropTypes.func,
	contest_points: PropTypes.number,
	prefferedGift: PropTypes.object,
	fetchData: PropTypes.func,
	userData: PropTypes.object,
	lists: PropTypes.object,
	saveInLocalStorage: PropTypes.func
};

class Circle extends React.Component {

	componentDidMount () {
		this.props.fetchData();
	}

	render() {
		const { contest_points, prefferedGift} = this.props;
		const percent = 100 * parseFloat(contest_points)/prefferedGift.price;
		const strokeDashoffset = percent < 100 ? 251 * (1  - percent/200) : 100;
		return (
			<Link className={cn({
				'circle__container': true,
				'display-none':_isEmpty(prefferedGift),
				'crossed-circle': !!prefferedGift.removed_at || prefferedGift.status === 'hidden'
			})}
			to={`market#good_${prefferedGift.id}`}
			>
				<svg height="50" width="50" className="circles">
					<circle cx="25" cy="25" r="20" strokeWidth="3" fill="white"
						style={{
							transition: 'stroke-dashoffset 1s linear',
							strokeDashoffset: 251 / 2
						}}
					/>
					<circle cx="25" cy="25" r="20" strokeWidth="3" fill="transparent"
						style={{
							transition: 'stroke-dashoffset 1s linear',
							strokeDashoffset
						}}
					/>
				</svg>
				<img src={prefferedGift.image} />
				<svg  height="50" width="50" className="cross">
					<line x1="10" y1="10" x2="40" y2="40" />
				</svg>
			</Link>
		);
	}
}

Circle.propTypes = propTypes;

const mapStateToProps = state => ({ prefferedGift: _get(state, 'profile.data.prefferedGift', {}) });

export default connect(mapStateToProps, dispatch => bindActionCreators(actions, dispatch))(Circle);


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/sidebar/balances/components/circle.js